import React from "react";
import { MasterConfigs } from "../../../../interfaces/entity";
import MasterComponent from "../../../../components/Forms";

const AssetUnavailableStatus = () => {
    const assetUnavailableStatus: MasterConfigs = {
        api: () => `/assets-unavailable-status`,
        title: 'Assets Unavailable Status',
        modalTitle: (action) => `${action} ${assetUnavailableStatus.title}`,
        actions: [{ actionType: 'Add', name: 'Add' }],
        isActionTab: true,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Short Code',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: 600,
                ellipsis: true
            },
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
        ],
    }



    return <MasterComponent config={assetUnavailableStatus} />
}

export default AssetUnavailableStatus;